import { DraftConfiguration } from '@/types';
import { isDraftDesignConfiguration } from './isDraftConfigurationType';

export function getIsAdultDesignConfiguration(configuration: DraftConfiguration): boolean {
  return isDraftDesignConfiguration(configuration) && configuration.design.safeSearch !== 'STRICT';
}
